import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-mm-wellcome',
    templateUrl: './mm-wellcome.component.html',
    styleUrls: ['./mm-wellcome.component.scss'],
})
export class MmWellcomeComponent implements OnInit {

    constructor(private modalCtrl: ModalController) { }

    ngOnInit() { }

    touchCloseModal() {
        this.modalCtrl.dismiss();
    }

}
